// src/components/PaymentCard.tsx
import React from 'react'
import { Lock } from 'lucide-react'

type PaymentSummaryItem = {
  label: string
  value: string
}

type PaymentCardProps = {
  amount: string
  summaryItems?: PaymentSummaryItem[]
  blurb?: string
  note?: string
  children: React.ReactNode
}

export default function PaymentCard({ amount, summaryItems, blurb, note, children }: PaymentCardProps) {
  return (
    <div className="payment-card">
      <div className="payment-card__header">
        <div className="payment-card__icon" aria-hidden>
          <Lock size={16} strokeWidth={1.8} />
        </div>
        <div>
          <div className="payment-card__eyebrow">Secure payment</div>
          <div className="payment-card__amount">{amount}</div>
          {blurb && <p className="payment-card__blurb">{blurb}</p>}
        </div>
      </div>

      {summaryItems && summaryItems.length > 0 && (
        <div className="payment-card__summary">
          {summaryItems.map(item => (
            <div key={`${item.label}-${item.value}`}>
              <div className="payment-card__summary-label">{item.label}</div>
              <div className="payment-card__summary-value">{item.value}</div>
            </div>
          ))}
        </div>
      )}

      <div className="payment-card__body">{children}</div>

      <p className="payment-card__note">{note || 'Processed by Stripe. We never store your card details.'}</p>
    </div>
  )
}
